import RichTextAreaInput from './RichTextAreaInput';

export * from './RichTextAreaInput';

export default RichTextAreaInput;
